import { LayoutGrid, List, type LucideIcon } from 'lucide-react';
import { cn } from '../../lib/utils';

interface ViewToggleProps {
	value: string;
	onChange: (value: string) => void;
	options?: Array<{ id: string; icon: LucideIcon; label: string }>;
}

const DEFAULT_OPTIONS: Array<{ id: string; icon: LucideIcon; label: string }> = [
	{ id: 'list', icon: List, label: 'List view' },
	{ id: 'card', icon: LayoutGrid, label: 'Card view' },
];

export function ViewToggle({ value, onChange, options = DEFAULT_OPTIONS }: ViewToggleProps) {
	return (
		<div className="inline-flex h-7 overflow-hidden rounded-lg border border-line-2 bg-surface-input">
			{options.map((v, i) => {
				const active = value === v.id;
				return (
					<button
						key={v.id}
						onClick={() => onChange(v.id)}
						title={v.label}
						aria-label={v.label}
						className={cn(
							'flex h-full w-7 cursor-pointer items-center justify-center transition-[background,color] duration-[120ms]',
							i > 0 && 'border-l border-line-2',
							active
								? 'bg-surface text-text-1'
								: 'bg-transparent text-text-3 hover:text-text-1'
						)}
					>
						<v.icon size={14} />
					</button>
				);
			})}
		</div>
	);
}
